import { useEffect, useRef, useState } from "react";
import { insertLocalTimeInString, translatePhrase } from "../../utils/functions";
import Typography from "../Typography/Typography";
import styles from "./Table.module.css";

type Props = {
	th: any;
	item: any;
	handleShowMore?: (title: string, text: string) => void;
};
const CustomCellWithViewMoreCTA = (props: Props) => {
	const { th, item, handleShowMore } = props;
	const contentRef = useRef<any>(null);
	const [showViewMore, setShowViewMore] = useState(false);

	useEffect(() => {
		const contentElement = contentRef.current;
		if (contentElement) {
			const isScrollable = contentElement.scrollHeight > contentElement.clientHeight;
			setShowViewMore(isScrollable);
		}
	}, [item]);

	return (
		<div>
			<td onClick={() => th.handleClick?.(item)} className={`col ${styles.string_col_item} ${th.td_class || ""}`}>
				<Typography
					type="text"
					size="sm"
					fontFamily="regular"
					color="tertiary"
					ref={contentRef}
					className={styles[`elipsis-${th.elipsis || 3}`]}
				>
					{typeof item[th.key] === "string"
						? insertLocalTimeInString(item[th.key].trim()) || translatePhrase("noDataAvailable")
						: item[th.key] || translatePhrase("noDataAvailable")}
				</Typography>

				{showViewMore && (
					<span className={styles.show_more_btn}>
						{"..."}
						<span className={styles.text_link} onClick={() => handleShowMore?.(th.title, item[th.key].trim())}>
							{translatePhrase("view_more")}
						</span>
					</span>
				)}
			</td>
		</div>
	);
};

export default CustomCellWithViewMoreCTA;
